import { render, staticRenderFns } from "./ChooseDays.vue?vue&type=template&id=5419f20d&"
import script from "./ChooseDays.vue?vue&type=script&lang=ts&"
export * from "./ChooseDays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports